export default __webpack_public_path__ + "static/media/ixodes.733362e6.jpg";